import { styled } from '@mui/system';
import { Box, Card } from '@mui/material';

export const Breadcrumb = styled(Box)({
  display    : 'flex',
  alignItems : 'center',
  gap        : '10px',

  a : {
    textDecoration : 'none',
  },
});

export const StyledCard = styled(Card)(({ theme }) => ({
  height       : '100%',
  background   : theme.palette.primary.white,
  border       : `1px solid ${theme.palette.primary.gray3}`,
  borderRadius : '10px',
  boxShadow    : 'none',
}));
